import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

/**
 * StickyConversionBar — verschijnt na 800px scroll
 * Mobielvriendelijke permanente CTA-balk onderaan
 */
const StickyConversionBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!dismissed) setVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [dismissed]);

  if (!visible || dismissed) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-blue-600 shadow-2xl"
      role="complementary"
      aria-label="Gratis adviesgesprek aanvragen"
      style={{ animation: 'slideUp 0.35s ease-out' }}
    >
      <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-3">
          {/* Left: value prop */}
          <div className="hidden md:block">
            <p className="text-sm font-black text-slate-900">Gratis offerte op maat — zonder verplichtingen</p>
            <p className="text-xs text-slate-500">Maandelijks opzegbaar &middot; Zelf installeren &middot; Hardware inbegrepen</p>
          </div>

          {/* CTAs */}
          <div className="flex items-center gap-3 w-full md:w-auto">
            <Link
              to="/offerte/"
              onClick={() => trackEvent('offerte_click', { location: 'sticky_bar' })}
              className="flex items-center justify-center px-5 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-sm transition-all flex-1 md:flex-none shadow-lg shadow-blue-200"
              id="sticky-bar-offerte"
            >
              Gratis Offerte <ArrowRight className="h-4 w-4 ml-1" aria-hidden="true" />
            </Link>
          </div>

          <button
            onClick={() => setDismissed(true)}
            className="ml-2 p-2 text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0"
            aria-label="Sluit balk"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyConversionBar;
